import Marquee from "react-fast-marquee";

const ITEMS = [
  "One deal a day",
  "Gone when it's gone",
  "Direct from UK retailers",
  "Pallets · Job lots · Clearance",
  "Members pay trade prices",
  "Graded stock · Verified manifests",
];

export const TickerMarquee = () => (
  <div className="border-y border-[#27272A] py-4 bg-[#0A0A0A]">
    <Marquee speed={35} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="mx-8 text-white/40 uppercase tracking-[0.25em] text-xs flex items-center gap-8">
          {t} <span className="text-[#FFCC00]">▪</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export const TrustStrip = () => (
  <div className="grid grid-cols-2 md:grid-cols-4 border border-[#27272A] divide-x divide-y md:divide-y-0 divide-[#27272A]">
    {[
      ["01", "Verified Manifests", "Every lot listed line by line"],
      ["02", "Condition Graded", "A / B / Returns — no surprises"],
      ["03", "UK Pallet Delivery", "Zone-priced, or collect free"],
      ["04", "Pay By Bank", "No card fees. Direct transfer"],
    ].map(([n, title, sub]) => (
      <div key={n} className="p-6 sm:p-8">
        <div className="text-[#FF3B30] text-xs mb-2">{n}</div>
        <div className="font-display text-lg text-white">{title}</div>
        <div className="text-white/40 text-xs mt-1">{sub}</div>
      </div>
    ))}
  </div>
);
